import { Fragment, useEffect, useState } from "react";
import "../../assets/styles/component/mobile/walletcardmob.scss";
import { FcPlus } from "react-icons/fc";
import { useTranslation } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";
import EmptyWallet from "../../assets/images/wallet_art.svg";
import moment from "moment";
import { apiJson } from "../../Api";
import { FaMinusCircle } from "react-icons/fa";

const RewardCardMob = () => {
  const { t } = useTranslation();
  const [rewards, setRewards] = useState([]);

  useEffect(() => {
    apiJson.rewards.getRewards().then((response) => {
      if (response.success) {
        setRewards(response.data);
      }
    });
  }, []);

  function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  return (
    <Fragment>
      <>
        {!rewards.length ? (
          <div className="wallet-empty-card-area">
            <div className="image-container">
              <img
                src={EmptyWallet}
                className="img-fluid"
                alt=""
                height="100%"
                width="100%"
              />
            </div>
            <div className="cart-text cart-head-text">
              {t("rewards.no-credit")}
            </div>
          </div>
        ) : (
          rewards.map((reward) => (
            <div
              key={reward.id}
              className="main-container-wallet-card-mobile px-3 mb-3 mt-3 pt-1 pb-2"
            >
              <div className="wallet-card-inner-container">
                <div className="main-row">
                  {reward.status === "expired" ? (
                    <FaMinusCircle color="red" size={18} />
                  ) : (
                    <FcPlus size={20} />
                  )}

                  <div className="card-first-row">
                    <div className="left">
                      <div className="return-refund-label">
                        <span className="returned-or-refunded">
                          {t("rewards.points")}
                        </span>
                      </div>
                    </div>
                    <div className="right">
                      <span
                        style={{
                          color:
                            reward.status === "expired" ||
                            reward.status === "used"
                              ? "#e00"
                              : "green",
                        }}
                      >
                        {reward.points}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="card-second-row mt-1 pb-1">
                  <div className="left">
                    <span className="date-ret-ref label-for-balance">
                      {moment(reward.created_at).format("ll")}
                    </span>
                  </div>
                  <div className="right">
                    <span className="balance-span label-for-balance">
                      {t("refer.status")}
                    </span>
                    <span className="balance-ammount">
                      : {capitalize(reward.status)}
                    </span>
                  </div>
                </div>

                <div
                  className="mt-1 pb-1"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginInlineStart: "24px",
                  }}
                >
                  <div className="left">
                    <span className="product-description">
                      {capitalize(reward.transaction_type)}
                    </span>
                  </div>
                  <div className="right">
                    <span className="balance-span label-for-balance">
                      {t("rewards.expiry_date")}
                    </span>
                    <span className="balance-ammount">
                      : {moment(reward.expires_at).format("ll")}
                    </span>
                  </div>
                </div>
                <div style={{ marginInlineStart: "24px" }}>
                  {reward.reward_credited ||
                    reward.reward_used ||
                    reward.reward_expired}
                </div>
              </div>
            </div>
          ))
        )}
      </>
    </Fragment>
  );
};

export default RewardCardMob;
